import { Component, Input } from '@angular/core';
import { StopType } from '../../../../shared/stop-type.model';

export type DeliveryNumberDisplayType = 'text' | 'badge';

@Component({
  selector: 'app-delivery-number',
  templateUrl: './delivery-number.component.html',
  styleUrls: ['./delivery-number.component.scss']
})
export class DeliveryNumberComponent {
  @Input() deliveryNumber: string;
  @Input() salesOrderNumber: string;
  @Input() displayType: DeliveryNumberDisplayType = 'text';
  @Input() stopType: StopType;
  @Input() showSalesOrderInline = false;

  public showTooltip = false;
  public tooltipX = 0;
  public tooltipY = 0;

  protected readonly StopType = StopType;

  onHover(event: MouseEvent): void {
    this.showTooltip = true;
    this.tooltipX = event.clientX;
    this.tooltipY = event.clientY;
  }

  onLeave(): void {
    this.showTooltip = false;
  }
}
